import { Component } from 'preact';
import style from './styles/RaffleBanner.scss';
import BlurredBackground from './BlurredBackground';
import RaffleService from '../../services/RaffleService';
import MutationService from '../../services/MutationService';
import { MobileSmallDown, MobileSmallUp, Desktop } from '../../helpers/MediaQueries';
import Raffle from '../../models/Raffle';
import DirectButtonLink from '../button/DirectButtonLink';

/**
 * @property {Raffle} props.raffle
 */
// eslint-disable-next-line react/prefer-stateless-function
class RaffleBanner extends Component {

	renderImageSlide(image) {
		return <div className={`${style.image}`} style={`background-image: url("${RaffleService.getImageUrl(image)}")`} />;
	}

	render() {
		const mutationCode = MutationService.getMutationCode();
		const raffle = this.props.raffle;
		const buttonText = raffle.soldout ? 'Shop other exclusives' : 'Shop on footshop';
		let desktopButtonLink = raffle.showLinkToFootshop()
			? <DirectButtonLink href={raffle.footshopLink} text={buttonText} showArrow />
			: <DirectButtonLink href={'#detail'} text={'See details'} showArrow />
		;
		return (
			<div className={style['banner-wrapper']}>
				<BlurredBackground raffle={raffle} />
				<div className="container no-padding">
					<div className={`${style.banner}`}>
						<MobileSmallUp>
							{this.renderImageSlide(raffle.getMainImage())}
						</MobileSmallUp>
						<MobileSmallDown>
							{this.renderImageSlide(raffle.getMainImage(Raffle.IMAGE_TYPE_PORTRAIT))}
						</MobileSmallDown>
						<div className={`${style['banner-elements']}`}>
							<div className={style['top-section']} >
								<h2 className={style.name}>{raffle.getTitle(mutationCode)}</h2>
								<div className={style.variant}>{raffle.getSubtitle(mutationCode)}</div>
								<div className={style.divider} />
							</div>
							<div className={style['bottom-section']} >
								<Desktop>
									{desktopButtonLink}
								</Desktop>
							</div>
						</div>
						<a className={style['scroll-down']} href={'#detail'}>
							<span className={style.arrow} />
						</a>
					</div>
				</div>
			</div>
		);
	}
}

export default RaffleBanner;





// WEBPACK FOOTER //
// ./components/raffle/RaffleBanner.js